import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import { useIsMobile } from "../../features/pageWidth/pageWidthSlice";
import { useAppDispatch } from "../../app/hooks";
import { closeDrawer } from "../../features/Drawer/drawerSlice";

const COOKIE_EXPIRATION_TIME = 365 * 100; // 100 years

const Tutorial: React.FC = () =>
{
    const [ run, setRun ] = useState( false );
    const isMobile = useIsMobile();
    const dispatch = useAppDispatch();
    const [ steps ] = useState<Array<Step>>( [
        {
            target: "body",
            content: (
                <React.Fragment>
                    <div><strong>👋 Welcome to RV Weather!</strong></div>
                    <div>This tutorial will walk you through the basics of SureRoute so you can start avoiding weather on the road.</div>
                </React.Fragment>
            ),
            disableBeacon: true,
            placement: "center",
        },
        {
            target: "body",
            content: (
                <React.Fragment>
                    <div><strong>The map shows weather impacts across the US, Mexico, and Canada.</strong></div>
                    {isMobile
                        ? "To explore the map, pinch to zoom and drag."
                        : "Drag, and zoom with the mouse to inspect the map."}
                </React.Fragment>
            ),
            disableBeacon: true,
            disableOverlay: true,
            placement: "center",
        },
        {
            target: "#step3",
            content: (
                <React.Fragment>
                    <div><strong>Legend</strong></div>
                    <div>The colors on the map represent the driving impact you will experience on the road.
                        Click the legend buttons to see a breakdown of what contributes to a given impact level
                    </div>
                </React.Fragment>
            ),
        },
        {
            target: "#step4",
            content: (
                <React.Fragment>
                    <div><strong>Additional Actions</strong></div>
                    <div>
                        {isMobile
                            ? "You can also control the map with these buttons. Tap the icons to see what they do."
                            : "You can also control the map with these buttons. Mouse over the icons to see what they do."}
                    </div>
                </React.Fragment>
            ),
        },
        {
            target: "#step5",
            content: (
                <React.Fragment>
                    <div><strong>Timeline</strong></div>
                    <div> To view different times in the forecast, you can interact with the timeline by dragging or pressing play.
                    </div>
                </React.Fragment>
            ),
        },
        {
            target: "#step6",
            content: (
                <React.Fragment>
                    <div><strong>Weather Impacts</strong></div>
                    <div> The map displays the aggregate impact of all conditions by default. To view a subset of weather
                        conditions, (e.g. rain, snow) click here.
                    </div>
                </React.Fragment>
            ),
        },
        {
            target: "#step7",
            content: (
                <React.Fragment>
                    <div><strong>Trip Library</strong></div>
                    <div> Here is the trip library where you can search created trips and create new trips.
                    </div>
                </React.Fragment>
            ),
        },
    ] );

    const handleJoyrideCallback = ( data: CallBackProps ) =>
    {
        const { action, status } = data;

        // Handle finished or skipped
        // "close" corresponds to clicking the x button in the top right of the modal.
        if ( status === STATUS.FINISHED || status === STATUS.SKIPPED || action === "close" )
        {
            Cookies.set( "hasSeenTutorial", "true", { expires: COOKIE_EXPIRATION_TIME } );
            setRun( false );
        }
    };

    useEffect( () =>
    {
        const hasSeenTutorial = Cookies.get( "hasSeenTutorial" );
        if ( hasSeenTutorial !== undefined )
        {
            setRun( false );
        }
        else
        {
            setRun( true );
            dispatch( closeDrawer( ) );
        }
    }, [] );

    return (
        <Joyride
            steps = {steps}
            run = {run}
            continuous
            showSkipButton
            showProgress
            callback = {handleJoyrideCallback}
            styles = {{
                options: {
                    zIndex: 10000,
                }
            }}
        />
    );
};

export default Tutorial;
